module.exports = __webpack_public_path__ + "static/media/encaixe.453d5d8c.mp4";